/**
 * Mock teacher data used as fallback when the API has no data yet.
 * Shape mirrors what the real /teacher-listing-web endpoint returns.
 */

const AVATARS = [];

const BASE_TEACHERS = [];

/** Generate `total` mock teachers recycling the base pool. */
export const generateMockTeachers = (total = 120) => {
  if (!BASE_TEACHERS || BASE_TEACHERS.length === 0) {
    return [];
  }
  const result = [];
  for (let i = 0; i < total; i++) {
    const base = BASE_TEACHERS[i % BASE_TEACHERS.length];
    result.push({
      ...base,
      _id: `mock-${i + 1}`,
      full_name: i < BASE_TEACHERS.length
        ? base.full_name
        : `${base.full_name} ${Math.floor(i / BASE_TEACHERS.length) + 1}`,
      profile_picture: AVATARS[i % AVATARS.length],
      review_count: Math.max(10, Math.round(base.review_count * (1 - i / (total * 1.5)))),
      follower_count: Math.max(50, Math.round(base.follower_count * (1 - i / (total * 1.5)))),
    });
  }
  return result;
};

/**
 * The first few teachers used in the hero globe avatars.
 */
export const HERO_AVATARS = AVATARS.slice(0, 4).map((src, i) => ({
  src,
  alt: BASE_TEACHERS[i]?.full_name || 'Teacher',
}));
